export enum WSEventType {
    OPEN = 'open',
    RECONNECT = 'reconnect',
    RECONNECT_COMPLETE = 'reconnectComplete',
    MESSAGE = 'message',
    ERROR = 'error',
    CLOSE = 'close',
    
}